import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MozoSesionProvider, useMozo } from './MozoSesion';
import MozoLogin from './MozoLogin';
import MozoMesas from './MozoMesas';
import MozoMesa from './MozoMesa';

// La app de mozos se instala aparte del sistema: tiene su propio manifiesto,
// nombre e ícono, y no muestra el menú de Driza Camp. El manifiesto del
// sistema se reemplaza mientras se está en /mozo (el navegador usa el primero
// que encuentra, por eso no alcanza con agregar otro).
function useIdentidadMozo() {
  useEffect(() => {
    const previos = Array.from(document.head.querySelectorAll('link[rel="manifest"]'));
    previos.forEach((enlace) => enlace.remove());

    const manifiesto = document.createElement('link');
    manifiesto.rel = 'manifest';
    manifiesto.href = '/mozo-manifest.json';
    document.head.appendChild(manifiesto);

    const iconoApple = document.createElement('link');
    iconoApple.rel = 'apple-touch-icon';
    iconoApple.href = '/mozo-apple-180.png';
    document.head.appendChild(iconoApple);

    const nombreApple = document.createElement('meta');
    nombreApple.name = 'apple-mobile-web-app-title';
    nombreApple.content = 'Driza Camp';
    document.head.appendChild(nombreApple);

    const colorAnterior = document.head.querySelector('meta[name="theme-color"]');
    const colorAnteriorValor = colorAnterior?.content;
    let color = colorAnterior;

    if (color) {
      color.content = '#166534';
    } else {
      color = document.createElement('meta');
      color.name = 'theme-color';
      color.content = '#166534';
      document.head.appendChild(color);
    }

    const titulo = document.title;
    document.title = 'Driza Camp';

    return () => {
      manifiesto.remove();
      iconoApple.remove();
      nombreApple.remove();
      previos.forEach((enlace) => document.head.appendChild(enlace));

      if (colorAnterior) {
        colorAnterior.content = colorAnteriorValor;
      } else {
        color.remove();
      }

      document.title = titulo;
    };
  }, []);
}

function Contenido() {
  const { sesion } = useMozo();

  if (!sesion) return <MozoLogin />;

  return (
    <Routes>
      <Route index element={<MozoMesas />} />
      <Route path="mesa/:id" element={<MozoMesa />} />
      <Route path="*" element={<Navigate to="/mozo" replace />} />
    </Routes>
  );
}

export default function MozoApp() {
  useIdentidadMozo();

  return (
    <MozoSesionProvider>
      <Contenido />
    </MozoSesionProvider>
  );
}
